import { render } from "./App.vue?vue&type=template&id=16a51319&bindings={\"header-component\":\"setup\",\"calendar-component\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script